import { isRequestError } from '~/common/services/requests';
import { TWO_FACTOR_VERIFICATION_FAILURE_MESSAGES } from '../constants/twoFactorVerificationFailureMessages';
import {
  TwoFactorVerificationFailure,
  TwoFactorVerificationFailureKey,
} from '../types/TwoFactorVerificationFailure';
import { getApiErrorMessage } from './getApiErrorMessage';

const THROTTLED_STATUS = 429;

const isVerificationFailureKey = (
  message: string,
): message is TwoFactorVerificationFailureKey =>
  Object.keys(TWO_FACTOR_VERIFICATION_FAILURE_MESSAGES).includes(message);

const asFailure = (
  key: TwoFactorVerificationFailureKey,
): TwoFactorVerificationFailure => ({
  key,
  message: TWO_FACTOR_VERIFICATION_FAILURE_MESSAGES[key],
});

export const getTwoFactorVerificationFailure = (
  error: unknown,
): TwoFactorVerificationFailure => {
  if (isRequestError(error) && error.response?.status === THROTTLED_STATUS) {
    return asFailure('two_factor.request_throttled');
  }

  const message = getApiErrorMessage(error, '');

  if (!isVerificationFailureKey(message)) {
    return { message };
  }

  return asFailure(message);
};
